<button matIconButton type="button" class="close" mat-dialog-close><mat-icon>close</mat-icon></button>
<h4 mat-dialog-title>{{ "trace.tab-tip-suggestions" | translate }} </h4>
<div class="legend-header flex-container container-space-between column">
    <div class="list-sub-header">{{ (data && data.suggestionsTabTitleI8nKey ? data.suggestionsTabTitleI8nKey : "trace.suggestions-route.title") | translate }}</div>
</div>
<mat-dialog-content class="tmv-dialog mat-typography surface-container-low">
    <div class="column ">
        <tt-trace-suggestions></tt-trace-suggestions>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close class="close-tip">{{'general.close'|translate}}</button>
</mat-dialog-actions>